import React from 'react';
import { MapPin, Phone } from 'lucide-react';
import Form from '..//Form/Form';
import './ContactUs.css';

const ContactUs = () => {
  return (
    <div className="contact-page">
      <div className="main-content">
        <div className="contact-container">
          <h1 className="main-title">Contact Us</h1>

          {/* Contact Cards Container */}
          <div className="contact-cards-wrapper">
            {/* Contact Details Card */}
            <div className="contact-card-center">
              <div className="logo-section">
                <div className="lotus-icon">🪷</div>
                <span className="logo-text">Pecunia Innovations</span>
              </div>
              
              <div className="profile-section">
                <div className="profile-image">
                  <div className="profile-placeholder">RP</div>
                </div>
                <div className="profile-info">
                  <h3>Mr. Raman Pasricha</h3>
                  <p>Director - Operations & Board Member</p>
                </div>
              </div>

              <div className="contact-details-center">
                <div className="detail-item">
                  <MapPin className="detail-icon" size={16} />
                  <div>
                    <h4>Address</h4>
                    <p>1111B, Indraprakash Building, Barakhamba Road, Connaught Place, New Delhi - 110001, India</p>
                  </div>
                </div>

                <div className="detail-item">
                  <Phone className="detail-icon" size={16} />
                  <div>
                    <h4>Contact Information</h4>
                    <p>+91-9810693894</p>
                    <p>+91-8527477833</p>
                    <p>+91-9818477883</p>
                    <p>ceo@pecuniainnovations.com</p>
                    <p>www.pecuniainnovations.com</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form Card */}
            <Form />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;